import { Icon, Text } from '@shared/widgets';
import PlusIcon from '@assets/icons/plus.svg';

interface AddInReportsProps {
  showModal: () => void;
}

export function AddInReports(props: AddInReportsProps) {
  return (
    <div className='flex items-center cursor-pointer' onClick={props.showModal}>
      <div className='mr-1 flex items-center justify-center w-4 h-4 opacity-60'>
        <Icon icon={<PlusIcon />} className='scale-75' />
      </div>
      <Text className='underline transition-opacity duration-200 hover:opacity-100'>Add</Text>
    </div>
  );
}
